import React from 'react';
import { Countdown } from './Countdown';
import { PRICE_AFTER_LAUNCH } from '../data/product';
export function Urgency() {
  return <section className="w-full bg-navy" data-id="element-536" data-mp="2bw5t8tbai5rq">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-16" data-id="element-537" data-mp="1wzf2f8fom2dq">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-hl" data-id="element-538" data-mp="1x1hrnq90frhe">Limited-time offer</p>
        <h2 className="mt-3 font-display text-2xl text-chalk sm:text-4xl" data-id="element-539" data-mp="220ktz2xlvjlo">The launch price ends in:</h2>
        <div className="mt-6" data-id="element-540" data-mp="1o58pw4xk8gs3">
          <Countdown data-id="element-541" data-mp="1sybpousxkmgq" />
        </div>
        <p className="mt-5 text-sm text-chalk/70" data-id="element-542" data-mp="1szcy0rikauur">
          After that the price goes up to <span className="font-bold text-clay-soft" data-id="element-543" data-mp="1e9ysjui3wxkn">${PRICE_AFTER_LAUNCH}</span> and stays there.
        </p>
      </div>
    </section>;
}